import request from '@/utils/request'
import axios from './index'

export function login (params) {
  return request.get('/HomePage')
}
export function logout () {
  return request.get('/logout')
}

export function modifyPassword (params) {
  return request.post('/modifyPassword', params)
}

/**
 * 滚动图
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectCarouselPicture (params) {
  return axios.post('/web_api/selectCarouselPicture', params)
}
